// import { t } from '../../../src/components/DetailTable.styles';
// import { MapItemTypeData } from '../DetailReport/detail/data';
// import ItemStateMap from '../DetailReport/detail/ItemState/ItemStateMap';

import styled from 'styled-components';
import { MapItemTypeData } from '../../detail/data';
import ItemStateMap from '../../detail/components/ItemState/ItemStateMap';

interface Props {
  type: string;
}

const ItemStatus = ({ type }: Props) => {
  const ChangeType = () => {
    const groupCategory = MapItemTypeData.find(
      (data) => data.name === type,
    )?.value;
    return groupCategory;
  };

  return (
    <Container id="물건현황">
      <div>물건현황</div>
      <ItemStateMap groupCategory={ChangeType() || ''} />
    </Container>
  );
};

export default ItemStatus;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 16px;
  background-color: #fff;
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;
